module.exports = __webpack_public_path__ + "img/animationassist-cn.148c601.jpg";